import { render } from "./CookieWarning.vue?vue&type=template&id=05ca6417"
import script from "./CookieWarning.vue?vue&type=script&lang=js"
export * from "./CookieWarning.vue?vue&type=script&lang=js"

import "./CookieWarning.vue?vue&type=style&index=0&id=05ca6417&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__